export const isLoadingHandler = (state, { payload }) => ({
    ...state,
    isLoading: payload,
});

export const areIntEqual = (value1, value2) => parseInt(value1, 10) === parseInt(value2, 10);



// WEBPACK FOOTER //
// ./src/store/Utils.js